(function () {
  if (window.__hbBenefitInit) return;
  window.__hbBenefitInit = true;

  var DEBOUNCE = 300;
  var RECONCILE_DELAY = 60;
  var writeTimers = {};

  function activateTab(bar, name) {
    if (!bar || !name) return;
    var panel = bar.querySelector('.hb-benefit-panel[data-panel="' + name + '"]');
    if (!panel) return;
    var tabs = bar.querySelectorAll('.hb-benefit-tab');
    for (var i = 0; i < tabs.length; i++) {
      var tabActive = tabs[i].getAttribute('data-tab') === name;
      tabs[i].classList.toggle('is-active', tabActive);
      tabs[i].setAttribute('aria-selected', tabActive ? 'true' : 'false');
    }
    var panels = bar.querySelectorAll('.hb-benefit-panel');
    for (var j = 0; j < panels.length; j++) {
      panels[j].classList.toggle('is-active', panels[j].getAttribute('data-panel') === name);
    }
  }

  function syncBars() {
    var bars = document.querySelectorAll('[data-hb-benefit-bar]');
    for (var i = 0; i < bars.length; i++) {
      var wanted = window.__hbActiveTab;
      if (!wanted || !bars[i].querySelector('.hb-benefit-panel[data-panel="' + wanted + '"]')) {
        wanted = bars[i].getAttribute('data-default-tab');
      }
      activateTab(bars[i], wanted);
    }
    snapshotBarLayout();
  }

  // ---- Animação de troca de posição dos nós (FLIP) ----
  // O drawer é repintado por innerHTML, então a régua nova já chega na posição
  // final. Guardamos a posição (left %) de cada nó da régua anterior e, quando a
  // nova entra com posições diferentes (ex.: frete liberado por cupom vai para o
  // início), cada nó parte da posição antiga e desliza até a nova.
  function firstKey(el) {
    var keys = (el.getAttribute('data-hb-keys') || '').split(' ');
    return keys[0] || '';
  }

  function readBarLayout(bar) {
    var layout = { nodes: {}, labels: {}, fill: null };
    if (!bar) return layout;
    var nodes = bar.querySelectorAll('.hb-benefit-node[data-hb-key]');
    for (var i = 0; i < nodes.length; i++) {
      layout.nodes[nodes[i].getAttribute('data-hb-key')] = parseFloat(nodes[i].style.left);
    }
    var labels = bar.querySelectorAll('.hb-benefit-cluster-label[data-hb-keys]');
    for (var j = 0; j < labels.length; j++) {
      layout.labels[firstKey(labels[j])] = parseFloat(labels[j].style.left);
    }
    var fill = bar.querySelector('.hb-benefit-track__fill');
    if (fill) layout.fill = parseFloat(fill.getAttribute('data-hb-fill') || fill.style.width);
    return layout;
  }

  // Guarda o layout da régua atual. Se a régua no DOM for outra (o drawer foi
  // repintado e o evento chegou antes do MutationObserver), trata como troca
  // e anima. Assim a ordem de chegada entre evento e observer não importa.
  function snapshotBarLayout() {
    var bar = document.querySelector('[data-hb-benefit-bar]');
    if (!bar) return;
    if (bar === window.__hbBarLayoutEl) return;
    animateBarChange(bar);
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function animateBarChange(bar) {
    if (!bar || bar === window.__hbBarLayoutEl) return;
    var prev = window.__hbBarLayout;
    var next = readBarLayout(bar);
    window.__hbBarLayout = next;
    window.__hbBarLayoutEl = bar;
    if (!prev || prefersReducedMotion()) return;
    var track = bar.querySelector('.hb-benefit-track');
    if (!track) return;
    var width = track.getBoundingClientRect().width;
    if (!width) return;

    var moving = [];
    function prepare(el, oldPct, newPct) {
      if (oldPct == null || isNaN(oldPct) || isNaN(newPct)) return;
      if (Math.abs(oldPct - newPct) < 0.01) return;
      var dx = ((oldPct - newPct) / 100) * width;
      el.classList.remove('is-flipping');
      el.style.setProperty('--hb-flip-dx', dx + 'px');
      moving.push(el);
    }
    var nodes = bar.querySelectorAll('.hb-benefit-node[data-hb-key]');
    for (var i = 0; i < nodes.length; i++) {
      var key = nodes[i].getAttribute('data-hb-key');
      prepare(nodes[i], prev.nodes[key], next.nodes[key]);
    }
    var labels = bar.querySelectorAll('.hb-benefit-cluster-label[data-hb-keys]');
    for (var j = 0; j < labels.length; j++) {
      var lkey = firstKey(labels[j]);
      prepare(labels[j], prev.labels[lkey], next.labels[lkey]);
    }

    var fill = bar.querySelector('.hb-benefit-track__fill');
    var fillMoves = fill && prev.fill != null && !isNaN(prev.fill) && Math.abs(prev.fill - next.fill) >= 0.01;
    if (!moving.length && !fillMoves) return;

    if (fillMoves) {
      fill.style.transition = 'none';
      fill.style.width = prev.fill + '%';
    }
    void bar.offsetWidth;
    requestAnimationFrame(function () {
      for (var m = 0; m < moving.length; m++) {
        moving[m].classList.add('is-flipping');
        moving[m].style.setProperty('--hb-flip-dx', '0px');
      }
      if (fillMoves) {
        fill.style.transition = '';
        fill.style.width = next.fill + '%';
      }
      setTimeout(function () {
        for (var k = 0; k < moving.length; k++) {
          moving[k].classList.remove('is-flipping');
          moving[k].style.removeProperty('--hb-flip-dx');
        }
      }, 600);
    });
  }

  function findAddedBars(mutations) {
    var bars = [];
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-hb-benefit-bar]')) bars.push(node);
        if (node.querySelectorAll) {
          var inner = node.querySelectorAll('[data-hb-benefit-bar]');
          for (var k = 0; k < inner.length; k++) bars.push(inner[k]);
        }
      }
    }
    return bars;
  }

  function buildPreviewThumbs(card) {
    var preview = card.querySelector('.hb-gift-options__preview');
    if (!preview) return;
    var options = card.querySelectorAll('.hb-gift-option:not(.is-selected)');
    while (preview.firstChild) {
      preview.removeChild(preview.firstChild);
    }
    var max = 3;
    var shown = 0;
    for (var i = 0; i < options.length && shown < max; i++) {
      var image = options[i].getAttribute('data-image');
      if (!image) continue;
      var thumb = document.createElement('span');
      thumb.className = 'hb-gift-thumb';
      var img = document.createElement('img');
      img.src = image;
      img.setAttribute('alt', '');
      img.setAttribute('loading', 'lazy');
      thumb.appendChild(img);
      preview.appendChild(thumb);
      shown++;
    }
    var more = card.querySelector('.hb-gift-options__more');
    if (more) {
      var extra = options.length - max;
      if (extra > 0) {
        more.textContent = '+' + extra;
        more.hidden = false;
      } else {
        more.hidden = true;
      }
    }
  }

  function updateMainCard(card) {
    var selected = card.querySelector('.hb-gift-option.is-selected');
    if (!selected) return;
    var img = card.querySelector('.hb-gift-main__img');
    var title = card.querySelector('.hb-gift-main__title');
    var selectedTitle = selected.getAttribute('data-title');
    var selectedImage = selected.getAttribute('data-image');
    if (img && selectedImage) {
      img.src = selectedImage;
      img.setAttribute('alt', selectedTitle || '');
    }
    if (title) {
      title.textContent = selectedTitle || '';
    }
  }

  function selectOption(card, gid) {
    var options = card.querySelectorAll('.hb-gift-option');
    for (var i = 0; i < options.length; i++) {
      var isSelected = options[i].getAttribute('data-variant-gid') === gid;
      options[i].classList.toggle('is-selected', isSelected);
      var radio = options[i].querySelector('input[type="radio"]');
      if (radio) radio.checked = isSelected;
    }
    updateMainCard(card);
    buildPreviewThumbs(card);
  }

  // Um mesmo produto não pode ficar reservado por dois marcos ao mesmo tempo.
  function releaseConflictingMarcos(marco, gid) {
    var released = [];
    var cards = document.querySelectorAll('.hb-gift-card');
    for (var i = 0; i < cards.length; i++) {
      var other = cards[i].getAttribute('data-marco');
      if (!other || other === marco) continue;
      var selected = cards[i].querySelector('.hb-gift-option.is-selected');
      if (selected && selected.getAttribute('data-variant-gid') === gid) released.push(other);
    }
    return released;
  }

  function persistChoice(marco, gid) {
    if (writeTimers[marco]) clearTimeout(writeTimers[marco]);
    var released = releaseConflictingMarcos(marco, gid);
    for (var r = 0; r < released.length; r++) {
      if (window.__hbIntent) delete window.__hbIntent[released[r]];
    }
    writeTimers[marco] = setTimeout(function () {
      if (window.Alpine && Alpine.store('xCartHelper')) {
        var attributes = {};
        attributes['_brinde_marco_' + marco] = gid;
        attributes['_brinde_optout_' + marco] = '';
        for (var c = 0; c < released.length; c++) {
          attributes['_brinde_marco_' + released[c]] = '';
        }
        Alpine.store('xCartHelper').updateCart({ attributes: attributes });
      }
    }, DEBOUNCE);
  }

  function initPreviews() {
    var cards = document.querySelectorAll('.hb-gift-card');
    for (var i = 0; i < cards.length; i++) {
      buildPreviewThumbs(cards[i]);
    }
  }

  // O drawer entra no DOM por innerHTML bem depois do load, e nem injetá-lo nem
  // abri-lo dispara evento de carrinho. A chegada do motor junto desse markup é o
  // sinal de que getMotor() passou a enxergar os dados e o carrinho pode ser
  // conferido.
  function addsMotorData(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.id === 'hb-motor-data') return true;
        if (node.querySelector && node.querySelector('#hb-motor-data')) return true;
      }
    }
    return false;
  }

  function observeGiftCards() {
    if (window.__hbGiftObserver || !window.MutationObserver) return;
    var target = document.getElementById('x-cart-drawer-container') || document.body;
    if (!target) return;
    // Fora do drawer o motor já vem no HTML da própria página e quem faz a primeira
    // sincronia é o reconcileOnLoad; conferir aqui também só repetiria esse trabalho.
    var watchesDrawer = target.id === 'x-cart-drawer-container';
    var pending = false;
    var motorPending = false;
    var observer = new MutationObserver(function (mutations) {
      var addedBars = findAddedBars(mutations);
      for (var b = 0; b < addedBars.length; b++) animateBarChange(addedBars[b]);
      if (watchesDrawer && !motorPending && addsMotorData(mutations)) {
        motorPending = true;
        requestAnimationFrame(function () {
          motorPending = false;
          scheduleReconcile();
        });
      }
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('.hb-gift-card')) || (node.querySelector && node.querySelector('.hb-gift-card'))) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initPreviews();
            });
            return;
          }
        }
      }
    });
    observer.observe(target, { childList: true, subtree: true });
    window.__hbGiftObserver = observer;
  }

  function toNumericId(value) {
    return String(value == null ? '' : value).split('/').pop();
  }

  function getMotor() {
    var el = document.getElementById('hb-motor-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readIntent(attributes) {
    var intent = {};
    if (attributes) {
      for (var key in attributes) {
        var match = key.match(/^_brinde_marco_(\d+)$/);
        if (match && attributes[key]) intent[match[1]] = attributes[key];
      }
    }
    var mem = window.__hbIntent || {};
    for (var n in mem) {
      if (mem[n]) intent[n] = mem[n];
    }
    return intent;
  }

  function withinSchedule(brinde, today) {
    if (!today) return true;
    var inicio = brinde.data_inicio ? String(brinde.data_inicio).slice(0, 10) : null;
    var fim = brinde.data_fim ? String(brinde.data_fim).slice(0, 10) : null;
    if (inicio && today < inicio) return false;
    if (fim && today > fim) return false;
    return true;
  }

  function dedupeKey(produto) {
    if (produto && produto.product_id) return 'p:' + toNumericId(produto.product_id);
    return 'v:' + toNumericId(produto && produto.variant_id);
  }

  function findByVariant(list, variantNum) {
    for (var i = 0; i < list.length; i++) {
      if (toNumericId(list[i].variant_id) === variantNum) return list[i];
    }
    return null;
  }

  // O marco escolhido por último tem prioridade na disputa por um produto repetido.
  function byIntentRecency(eligible) {
    var recency = window.__hbIntentOrder || [];
    return eligible.slice().sort(function (a, b) {
      var ra = recency.lastIndexOf(a.marco);
      var rb = recency.lastIndexOf(b.marco);
      if (ra === rb) return Number(a.marco) - Number(b.marco);
      return rb - ra;
    });
  }

  // Mesma base da régua (benefit-bar-unified.liquid): total do carrinho menos
  // as linhas de brinde. cart.total_price já inclui descontos de pedido (cupom
  // percentual, por exemplo); final_line_price dos itens não inclui, e usar a
  // soma deles fazia o JS liberar o brinde enquanto a régua dizia que faltava.
  function eligibleCents(cart) {
    var giftCents = 0;
    var lineCents = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.properties && it.properties._gift === 'true') {
        giftCents += it.final_line_price;
      } else {
        lineCents += it.final_line_price;
      }
    }
    if (typeof cart.total_price === 'number') return cart.total_price - giftCents;
    return lineCents;
  }

  // Trava anti-loop: se o mesmo marco fica entrando e saindo sem o cliente
  // mexer nos itens (ex.: a entrada do brinde derruba um cupom e o valor cai
  // abaixo do marco), para de mexer até os itens mudarem.
  var LOOP_WINDOW = 120000;
  var LOOP_MAX_FLIPS = 2;

  // Itens (sem brinde) + cupons digitados. Cupom entra pelo código, não pela
  // aplicabilidade: num loop a aplicabilidade oscila sozinha, o código não.
  // Quando o cliente mexe nos itens ou nos cupons, a assinatura muda e a trava
  // é zerada.
  function nonGiftSignature(cart) {
    var parts = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.properties && it.properties._gift === 'true') continue;
      parts.push(it.key + 'x' + it.quantity);
    }
    var codes = [];
    var list = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    for (var c = 0; c < list.length; c++) {
      if (list[c] && list[c].code) codes.push(String(list[c].code).toLowerCase());
    }
    return parts.sort().join('|') + '#' + codes.sort().join(',');
  }

  function loopGuardAllows(cart, addMarcos, removeMarcos) {
    var sig = nonGiftSignature(cart);
    var now = Date.now();
    var guard = window.__hbLoopGuard;
    if (!guard || guard.sig !== sig || now - guard.last > LOOP_WINDOW) {
      guard = window.__hbLoopGuard = { sig: sig, last: now, lastAction: {}, flips: {}, blocked: false };
    }
    guard.last = now;
    if (guard.blocked) return false;

    var actions = {};
    var m;
    for (m = 0; m < addMarcos.length; m++) actions[addMarcos[m]] = 'add';
    for (m = 0; m < removeMarcos.length; m++) {
      // remove + add do mesmo marco na mesma rodada é troca de opção, não vai e volta
      actions[removeMarcos[m]] = actions[removeMarcos[m]] === 'add' ? 'swap' : 'remove';
    }
    for (var marco in actions) {
      if (!Object.prototype.hasOwnProperty.call(actions, marco)) continue;
      var action = actions[marco];
      if (action === 'swap') continue;
      var previous = guard.lastAction[marco];
      if (previous && previous !== action) {
        guard.flips[marco] = (guard.flips[marco] || 0) + 1;
        if (guard.flips[marco] >= LOOP_MAX_FLIPS) {
          guard.blocked = true;
          return false;
        }
      }
      guard.lastAction[marco] = action;
    }
    return true;
  }

  // CEP salvo pelo fluxo de entrega expressa (mesma chave do gift-express-warning.js).
  function savedExpressCep() {
    try {
      var raw = localStorage.getItem('haoma-cep-express');
      if (!raw) return '';
      var data = JSON.parse(raw);
      return data && data.cep ? String(data.cep) : '';
    } catch (e) {
      return '';
    }
  }

  // O opt-out do brinde nasce no aviso de entrega expressa: o cliente tira o
  // brinde para manter o expresso naquele CEP. Por isso ele só vale enquanto o
  // CEP salvo for o mesmo que o gerou. Valores antigos ("true", sem CEP) não
  // valem mais: ficavam presos no carrinho para sempre.
  function giftOptedOut(cart, marco) {
    var value = cart.attributes ? cart.attributes['_brinde_optout_' + marco] : '';
    if (!value || value === 'true') return false;
    var cep = savedExpressCep();
    return !!cep && String(value) === cep;
  }

  function computeDesired(motor, cart) {
    var brinde = motor && motor.brinde;
    if (!brinde || brinde.ativo !== true) return [];
    if (!withinSchedule(brinde, motor.hoje)) return [];
    var marcos = brinde.marcos || [];
    if (!marcos.length) return [];

    var netCents = eligibleCents(cart);

    var intent = readIntent(cart.attributes);
    var eligible = [];
    for (var m = 0; m < marcos.length; m++) {
      var n = String(m + 1);
      if (giftOptedOut(cart, n)) continue;
      var marco = marcos[m];
      var threshold = Math.round(Number(marco.valor_minimo) * 100);
      if (!isFinite(threshold) || netCents < threshold) continue;
      var pool = marco.produtos || [];
      var avail = [];
      for (var p = 0; p < pool.length; p++) {
        if (pool[p].disponivel === true) avail.push(pool[p]);
      }
      if (!avail.length) continue;
      eligible.push({ marco: n, avail: avail });
    }
    if (!eligible.length) return [];

    var used = {};
    var picked = {};

    var ordered = byIntentRecency(eligible);
    for (var e = 0; e < ordered.length; e++) {
      var wanted = intent[ordered[e].marco];
      if (!wanted) continue;
      var match = findByVariant(ordered[e].avail, toNumericId(wanted));
      if (!match) continue;
      var wantedKey = dedupeKey(match);
      if (used[wantedKey]) continue;
      used[wantedKey] = true;
      picked[ordered[e].marco] = match;
    }

    for (var f = 0; f < eligible.length; f++) {
      if (picked[eligible[f].marco]) continue;
      var avails = eligible[f].avail;
      for (var a = 0; a < avails.length; a++) {
        var fallbackKey = dedupeKey(avails[a]);
        if (used[fallbackKey]) continue;
        used[fallbackKey] = true;
        picked[eligible[f].marco] = avails[a];
        break;
      }
    }

    var desired = [];
    for (var g = 0; g < eligible.length; g++) {
      var chosen = picked[eligible[g].marco];
      if (!chosen) continue;
      desired.push({ marco: eligible[g].marco, variant: toNumericId(chosen.variant_id) });
    }
    return desired;
  }

  function currentGiftLines(cart) {
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!it.properties || it.properties._gift !== 'true') continue;
      lines.push({
        key: it.key,
        marco: it.properties._marco != null ? String(it.properties._marco) : '',
        variant: toNumericId(it.variant_id),
        quantity: it.quantity
      });
    }
    return lines;
  }

  // O carrinho devolvido pela última alteração serve para decidir os brindes sem
  // uma nova consulta. Só vale por instantes e uma única vez: qualquer alteração
  // seguinte substitui ou limpa o instantâneo.
  function takeCartSnapshot() {
    var snapshot = window.__hbCartSnapshot;
    window.__hbCartSnapshot = null;
    if (!snapshot || !snapshot.cart) return null;
    if (Date.now() - snapshot.at > 1500) return null;
    return snapshot.cart;
  }

  function sectionIds() {
    // A API do carrinho aceita poucas seções por requisição; as demais são
    // repintadas depois pelo próprio helper.
    return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
      return s.id;
    }).slice(0, 5);
  }

  function changeLine(key, quantity, includeSections) {
    var body = { id: key, quantity: quantity };
    if (includeSections !== false) {
      body.sections = sectionIds();
      body.sections_url = window.location.pathname;
    }
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json();
    });
  }

  function addLines(items) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionIds(),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) return null;
      return r.json();
    });
  }

// Revalida a garrafa sempre que um cupom for aplicado ou alterado
document.addEventListener('eurus:cart:discount-code:change', function() {
  validateRowaGiftAfterDiscount();
});
  function applyIntent() {
    var mem = window.__hbIntent || {};
    var cards = document.querySelectorAll('.hb-gift-card');
    for (var i = 0; i < cards.length; i++) {
      var marco = cards[i].getAttribute('data-marco');
      if (mem[marco]) selectOption(cards[i], mem[marco]);
    }
  }

  function showGiftLoading(marcos) {
    if (!marcos || !marcos.length) return;
    for (var i = 0; i < marcos.length; i++) {
      var cards = document.querySelectorAll('.hb-gift-card[data-marco="' + marcos[i] + '"]');
      for (var c = 0; c < cards.length; c++) {
        var anchor = cards[c].closest('.hb-gift-line') || cards[c];
        if (anchor.querySelector('.hb-gift-loading')) continue;
        var overlay = document.createElement('div');
        overlay.className = 'hb-gift-loading absolute hidden top-0 bottom-0 h-full w-full';
        overlay.innerHTML =
          '<div class="absolute top-0 right-0 w-full h-full opacity-20 bg-black"></div>' +
          '<div class="loading-cover"><span class="loading-bar absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></span></div>';
        anchor.appendChild(overlay);
        overlay.classList.remove('hidden');
      }
    }
  }

  function hideGiftLoading() {
    var nodes = document.querySelectorAll('.hb-gift-loading');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  function readScrollPositions() {
    var positions = {};
    var nodes = document.querySelectorAll('#CartDrawer [data-hb-scroll]');
    for (var i = 0; i < nodes.length; i++) {
      positions[nodes[i].getAttribute('data-hb-scroll')] = nodes[i].scrollTop;
    }
    return positions;
  }

  function restoreScrollPositions(positions) {
    if (!positions) return;
    requestAnimationFrame(function () {
      for (var name in positions) {
        if (!Object.prototype.hasOwnProperty.call(positions, name)) continue;
        var el = document.querySelector('#CartDrawer [data-hb-scroll="' + name + '"]');
        if (!el) continue;
        var max = el.scrollHeight - el.clientHeight;
        if (max < 0) max = 0;
        el.scrollTop = Math.min(positions[name], max);
      }
    });
  }

  async function reconcileGifts() {
    if (!window.Alpine || !Alpine.store('xCartHelper')) return;
    var motor = getMotor();
    if (!motor) return;
    window.__hbReconciling = true;
    try {
      await Alpine.store('xCartHelper').waitForCartUpdate();
      var cart = takeCartSnapshot();
      if (!cart) {
        cart = await fetch(window.Shopify.routes.root + 'cart.js', {
          headers: { Accept: 'application/json' }
        }).then(function (r) {
          return r.json();
        });
      }

      // Mantém cart.attributes._cupom_frete alinhado com os cupons aplicáveis
      // (cobre cupom removido no checkout ou aplicado por link).
      var syncedSections = null;
      if (window.hbSyncShippingCoupon) {
        var synced = await window.hbSyncShippingCoupon(cart);
        if (synced && synced.items) {
          cart = synced;
          syncedSections = synced.sections || null;
        }
      }

      var desired = computeDesired(motor, cart);
      var current = currentGiftLines(cart);

      var desiredSet = {};
      for (var d = 0; d < desired.length; d++) {
        desiredSet[desired[d].marco + ':' + desired[d].variant] = true;
      }

      var kept = {};
      var toRemove = [];
      var removeMarcos = [];
      for (var c = 0; c < current.length; c++) {
        var sig = current[c].marco + ':' + current[c].variant;
        if (desiredSet[sig] && current[c].quantity === 1 && !kept[sig]) {
          kept[sig] = true;
        } else {
          toRemove.push(current[c].key);
          removeMarcos.push(current[c].marco);
        }
      }

      var toAdd = [];
      var addMarcos = [];
      for (var a = 0; a < desired.length; a++) {
        var sig2 = desired[a].marco + ':' + desired[a].variant;
        if (kept[sig2]) continue;
        toAdd.push({
          id: desired[a].variant,
          quantity: 1,
          properties: { _gift: 'true', _marco: desired[a].marco }
        });
        addMarcos.push(desired[a].marco);
        kept[sig2] = true;
      }

      var hasChanges = toRemove.length > 0 || toAdd.length > 0;
      if (hasChanges && !loopGuardAllows(cart, addMarcos, removeMarcos)) {
        hasChanges = false;
      }

      if (!hasChanges) {
        if (syncedSections) {
          var syncScroll = readScrollPositions();
          await Alpine.store('xCartHelper').reRenderSections(syncedSections);
          restoreScrollPositions(syncScroll);
        }
        syncBars();
        initPreviews();
        return;
      }

      var lastSections = syncedSections;
      showGiftLoading(removeMarcos);
      window.updatingCart = true;
      try {
        for (var r = 0; r < toRemove.length; r++) {
          var removed = await changeLine(toRemove[r], 0, toAdd.length === 0);
          if (removed && removed.sections) lastSections = removed.sections;
        }
        if (toAdd.length) {
          var added = await addLines(toAdd);
          if (added && added.sections) lastSections = added.sections;
        }
      } finally {
        window.updatingCart = false;
      }

      // Toda mutação termina repintando o carrinho. Quando a resposta não traz o
      // HTML das seções, o helper busca por conta própria em vez de deixar a
      // lista mostrando o estado anterior até o cliente recarregar a página.
      var scrollPositions = readScrollPositions();
      await Alpine.store('xCartHelper').reRenderSections(lastSections || null);
      restoreScrollPositions(scrollPositions);
      syncBars();
      initPreviews();
      applyIntent();
    } catch (e) {
    } finally {
      window.updatingCart = false;
      window.__hbReconciling = false;
      hideGiftLoading();
    }
  }

  function runReconcile() {
    if (window.__hbReconciling) {
      window.__hbReconcileTimer = setTimeout(runReconcile, RECONCILE_DELAY);
      return;
    }
    reconcileGifts();
  }

  function scheduleReconcile() {
    clearTimeout(window.__hbReconcileTimer);
    window.__hbReconcileTimer = setTimeout(runReconcile, RECONCILE_DELAY);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('.hb-benefit-tab') : null;
    if (tab) {
      e.preventDefault();
      var bar = tab.closest('[data-hb-benefit-bar]');
      var name = tab.getAttribute('data-tab');
      window.__hbActiveTab = name;
      activateTab(bar, name);
      return;
    }
    var toggle = e.target.closest ? e.target.closest('.hb-gift-options__toggle') : null;
    if (toggle) {
      var wrap = toggle.closest('.hb-gift-options');
      var expanded = wrap.getAttribute('data-expanded') === 'true';
      wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }
  });

  document.addEventListener('change', function (e) {
    var option = e.target.closest ? e.target.closest('.hb-gift-option') : null;
    if (!option) return;
    var card = option.closest('.hb-gift-card');
    if (!card) return;
    var gid = option.getAttribute('data-variant-gid');
    var marco = card.getAttribute('data-marco');
    selectOption(card, gid);
    if (!window.__hbIntent) window.__hbIntent = {};
    window.__hbIntent[marco] = gid;
    if (!window.__hbIntentOrder) window.__hbIntentOrder = [];
    window.__hbIntentOrder.push(marco);
    persistChoice(marco, gid);
    scheduleReconcile();
  });

  document.addEventListener('eurus:cart:items-changed', function (e) {
    window.__hbCartSnapshot =
      e && e.detail && e.detail.cart && e.detail.cart.items
        ? { cart: e.detail.cart, at: Date.now() }
        : null;
    syncBars();
    initPreviews();
    scheduleReconcile();
  });

  document.addEventListener('eurus:product:added', function () {
    if (window.__hbReconciling) return;
    syncBars();
    initPreviews();
  });

  // Na página /cart não existe cart drawer para disparar a primeira sincronia,
  // então o carrinho é conferido assim que a loja termina de subir o Alpine.
  function reconcileOnLoad() {
    if (!document.getElementById('hb-motor-data')) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
        clearInterval(timer);
        scheduleReconcile();
      } else if (++tries > 50) {
        clearInterval(timer);
      }
    }, 100);
  }

  syncBars();
  initPreviews();
  observeGiftCards();
  reconcileOnLoad();
})();
